<template>
  <div class="warpConss">
 
    <el-collapse v-model="openIndex" accordion>
      <el-collapse-item v-for="(grounp, grounpIndex) in CourseList" :key="grounpIndex" :name="grounpIndex">
        <template slot="title">
          <div class="title-grounp"> 
            <img style="width: 16px; height: 14.5px; margin-right: 11px" src="https://staticfile.xlcwx.com/m-images/yth/lzjxy/img/typeclass/tip.png" alt="">
            <span style="color: #333333; font-size: 16px" class="ellipsis">
              {{ grounp.videoChapterName }}</span>
            <span class="kc_time">{{ grounp.ksTime }}课时</span>
           
          </div>
        </template>
        <div v-for="(item, index) in grounp.queryVideoNodeList" :key="index" class="chat-item" :class="(item.audition && item.audition != '0') || IsPurchase
          ? 'canVideo'
          : ''
          ">
          <div class="item-title" @click.stop="check(item, grounp, grounpIndex)">
            <i v-if="(item.audition && item.audition != '0') || IsPurchase" class="iconfont icon-a-Union21" />
            <i v-else class="iconfont icon-suotou" />
            <div class="title ellipsis">
              {{ item.nodeName }}
            </div>
            <span class="kc_time">{{ item.ksTime }}课时</span>
            
          </div>
          <div class="but-list">
            <div :class="(item.audition && item.audition != '0') || IsPurchase ? '' : 'noLives'">
              <div v-if="item.whetherAttachment" class="keep-learn" @click.stop="ktData(item, 1)">
                随堂讲义
              </div>
              <div v-if="item.whetherPaper" class="keep-learn" @click.stop="cgeckTask(item)">
                随堂测试
              </div>
              <div v-if="item.whetherMeans" class="keep-learn"
                @click.stop="ktData(item, 2)">
                随堂资料
              </div>
            </div>
            
          </div>
        </div>
      </el-collapse-item>
    </el-collapse>
   
  
  </div>
</template>
<script> 
import Vue from 'vue' 
import { getInfo, getDomainToken } from '@/api/cookies'
 

export default {
  props: {
    id: {},
    playid: {},
    list: {},
 
    classId: {}, 
      courseId: {
      
    },
  },
  data() {
    return {
      userInfo: null, 
      CourseList: [],
      dialogVisible: false,
      ifDialog: false, 
      dialogList: null,
      DomainAuthorization: getDomainToken(),
      openIndex: 0,
      lookDeatil: null,
      IsPurchase: false
    }
  },
 
  created() {
    this.userInfo = getInfo()
  
      this.CourseList = this.list
   
  },
  methods: {
   
    // 课堂作业
    cgeckTask(item) {

      Vue.prototype.goExam(      {contactId:item.paperId,examType:6}      );

     
    },
    
    // 随堂资料
    ktData(item, type) {
      const userInfo = getInfo()
      if (!userInfo) {
        Vue.prototype.goLoginView(false)
        return
      }
      // if (!this.IsPurchase) {
      //   this.dialogVisible = true
      //   return
      // }
     
 try {
        const params = new URLSearchParams({
          type: type,
          ChatId: item.videoChapterId,
          courseId: this.courseId,
        });
        window.open(`/data/dataPackageDetail?${params.toString()}`, "_blank");
      } catch (error) {
        console.error("打开资料详情失败:", error);
      }
  
    }
  }
}
</script>
<style lang="less" scoped>
.warpConss {
  padding: 32px;
  background: #fff;
}

/deep/ .el-collapse-item__arrow {
  width: 8px !important;
  display: block;
  height: 16px !important;
  background-image: url("https://staticfile.xlcwx.com/m-images/yth/lzjxy/img/vipxq/right.png") !important;
  background-size: 100% 100% !important;
}

 
/deep/ .el-collapse {
  border: none !important;
  

  .is-active {
    .el-collapse-item__arrow {
      width: 16px !important;
      display: block;
      height: 8px !important;
      background-image: url("https://staticfile.xlcwx.com/m-images/yth/lzjxy/img/vipxq/bottom.png") !important;
      background-size: 100% 100% !important;
    }
  }

  .el-collapse-item {
    margin-bottom: 10px;

    &:last-child {
      margin-bottom: 20px;
    }
  }

  .el-collapse-item__wrap {
    margin-top: 10px;
  }

  .el-collapse-item__header {
    height: 46px;
    border: none !important;
  

    .title-grounp {
      display: flex;
      align-items: center;
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #333333;

      .dian {
        width: 6px;
        height: 6px;
        background: #333333;
        opacity: 1;
        border-radius: 50%;
        margin-right: 8px;
        flex-shrink: 0;
      }

      .kc_time {
        flex-shrink: 0;

        height: 22px;
        line-height: 22px;
        background: #ffffff;
        border-radius: 4px 4px 4px 4px;
        opacity: 1;
        padding: 1px 8px;

        font-size: 14px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        margin-left: 10px;
      }
    }
  }

  .is-active {
    .el-collapse-item__arrow {
      background-image: url("https://staticfile.xlcwx.com/m-images/yth/lzjxy/img/vipxq/bottom.png");
    }
  }
}

/* 购买提示 */
.warpCpons {
  // position: absolute;
  position: fixed;
  z-index: 2000;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  background: rgba(0, 0, 0, 0.6);

  div {
    width: 610px;
    height: auto;
    display: flex;
    z-index: 20;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    background: rgba(255, 255, 255, 0);

    .imga {
      width: 100%;
      height: 420px;
    }

    .imgb {
      width: 36px;
      height: 36px;
      margin-top: 30px;
      cursor: pointer;
    }

    span {
      width: 100%;
      height: auto;
      text-align: center;
      font-size: 20px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #6c90fe;
      margin-top: -160px;
    }
  }
}

/* 试听 */
.audition {
  width: 48px;
  height: 20px;
  background: #ffedeb;
  border-radius: 2px 2px 2px 2px;
  font-size: 12px;
  font-family: Microsoft YaHei-Regular;
  font-weight: 400;
  color: #ff5e51;
  line-height: 20px;
  margin-left: 8px;
  text-align: center;
}

/* 节 */
.canVideo {
  .item-title {
    display: flex;
    width: calc(100% - 300px);
    align-items: center;
    cursor: pointer;

    .iconfont {
      font-size: 14px;
      margin-right: 12px;
      color: #333333 !important;
      flex-shrink: 0;
    }

    .title {
      font-size: 16px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #333333 !important;
      line-height: 14px;
    }
  }
}

.chat-item {
  // border-bottom: 1px solid #eee;
  width: 100%;
  height: 40px;
  padding: 0 68px 0 60px !important;
  display: flex;
  justify-content: space-between;
  margin: 0px auto !important;

  .item-title {
    display: flex;
    width: calc(100% - 300px);
    align-items: center;
    cursor: pointer;

    .iconfont {
      font-size: 14px;
      margin-right: 12px;
      flex-shrink: 0;
      color: #999999;
    }

    .title {
      font-size: 16px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #999999;
      line-height: 16px;
    }

    .kc_time {
      height: 22px;
      line-height: 22px;
      background: #f5f5f5;
      border-radius: 4px 4px 4px 4px;
      opacity: 1;
      flex-shrink: 0;

      font-size: 14px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      margin-left: 10px;
      padding: 1px 6px;
    }
  }

  .but-list {
    flex-shrink: 0;
    display: flex;
    width: 240px;
    justify-content: flex-end;
    align-items: center;

    .keep-learn {
      margin-right: 12px;
      flex-shrink: 0;
      width: 72px;
      height: 24px;
      border-radius: 4px 4px 4px 4px;
      opacity: 1;
      border: 1px solid #ff5e51;
      padding: 0px;
      text-align: center;
      line-height: 24px;

      &:last-child {
        margin-right: 0px;
      }
    }
  }
}

.lookBg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;

  .ifLook {
    width: 500px;
    background-color: #fff;
    padding: 10px;
    border-radius: 10px;
    border: 1px solid #ccc;

    .contents {
      width: 380px;
      margin: 20px auto;

      &>span {
        color: red;
      }
    }

    .button {
      width: 120px;
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0 auto;
      border-radius: 10px;
      border: 1px solid #ccc;
      cursor: pointer;
    }
  }
}

.noLives {
  .keep-learn {
    border: 1px solid #dddddd !important;

    border-radius: 4px 4px 4px 4px;
    color: #aaaaaa;
  }
}
</style><style lang="less"></style>
